import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import html2pdf from "html2pdf.js";
import PdfTemplate from '../../component/Print1.js';
import ReactDOMServer from 'react-dom/server';




export default function CourseVerification() {


  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/admin/");
  }

  const tableRef = useRef(null);


  const [semester_id, setSemester] = useState("");
  const [candidateType, setCandidateType] = useState(1);
  const collegename = localStorage.getItem('username');

  const [loading, setlodaing] = useState(false);
  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);
  const [disciplineId, setDisciplineChange] = useState(null);
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);

  const [filteredStudents, setFilteredStudents] = useState([]);
  // Holds the fetched students based on discipline
  const currentDate = new Date();

  const { http } = Api();





  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),

  };
  
  //custom discipline style
  const disciplineStyles = {

    option: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();  // SF / AIDED

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      if (state.isSelected) {
        return {
          ...provided,
          backgroundColor: "#ebebeb",
          color: color,   // KEEP suffix color even when selected
          fontWeight: "600",
        };
      }

      return {
        ...provided,
        color: color,
      };
    },

    // THIS makes the selected item in the select box colored
    singleValue: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      return {
        ...provided,
        color: color,
        fontWeight: "600",
      };
    },
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/Admin/getActiveAdmissionYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
      }
    };
    fetchAdmissionYears()
  }, [admissionYear]);


  const handleDisciplineChange = (selectedOption) => {
    setDisciplineChange(selectedOption.did);
    setDisciplineNameChange(selectedOption.value);
    setDisciplineTypeChange(selectedOption.type);
  };

  const handleAdmissionYearChange = (selectedOption) => {
    setAdmissionYear(selectedOption.value);
  };




  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/Admin/getCollegeDisciplines`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response.data);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, [cid, navigate]);




  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const response = await http.get(`/College/viewCourseVerificationList`, {
          params: {
            admissionyear: admissionYear,
            semester_id: semester_id,
            discipline_id: disciplineId,
            inside_outside: candidateType,
            college_course_type: disciplinetype

          },
        });

        const studentsData = response.data.studentlist;
        setFilteredStudents(Object.entries(studentsData));
      } catch (error) {
        console.error("Error fetching student data:", error);
        setFilteredStudents([]);
      }
    };

    if (admissionYear && semester_id && disciplineId) {
      fetchTableData();
    }

  }, [admissionYear, semester_id, disciplineId, disciplinetype, disciplineName, candidateType]);




  const handleGeneratePrintPDF = async () => {
    let date = new Date();
    try {
      const response = await http.get(`/getDateandTime`);
      date = response.data;
    } catch (error) {
      if (error.response?.data?.status_code === 'ERR9') {
        toast.error("Invalid token");
        setTimeout(() => {
          navigate('/');
        }, 5000);
      }
      return;
    }

    if (!Array.isArray(filteredStudents) || filteredStudents.length === 0) {
      toast.error("No data found");
      return;
    }

    try {
      setlodaing(true);

      const chunkSize = 80;
      const studentChunks = [];
      for (let i = 0; i < filteredStudents.length; i += chunkSize) {
        studentChunks.push(filteredStudents.slice(i, i + chunkSize));
      }

      const generatePDFForChunk = async (chunk, index) => {
        const element = <PdfTemplate data={chunk} />;
        const pdfElement = document.createElement('div');
        pdfElement.innerHTML = ReactDOMServer.renderToStaticMarkup(element);

        const config = {
          margin: [40, 20, 60, 20],
          filename: `${collegename}_course_list_part${index + 1}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: {
            scale: 2,
            useCORS: true,
            letterRendering: true,
            scrollY: -window.scrollY,
          },
          jsPDF: {
            unit: 'pt',
            format: 'a4',
            orientation: 'portrait',
            compressPDF: true,
          },
          pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        };

        return html2pdf().from(pdfElement).set(config).toPdf().get('pdf').then(async (pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          // Create watermark canvas (moved outside the page loop)
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = pageWidth;
          canvas.height = pageHeight;

          ctx.fillStyle = 'rgba(200, 200, 200, 0.5)';
          ctx.font = '60px Helvetica';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.save();
          ctx.translate(pageWidth / 2, pageHeight / 2);
          ctx.rotate(Math.PI / 4);
          ctx.fillText("DRAFT", 0, 0);
          ctx.restore();

          const imgData = canvas.toDataURL('image/png');

          for (let j = 1; j <= totalPages; j++) {
            pdf.setPage(j);
            pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight);

            pdf.setFontSize(10);
            pdf.setTextColor(88, 31, 55);
            pdf.setDrawColor(88, 31, 55);
            pdf.setLineWidth(0.5);
            pdf.line(20, pageHeight - 30, pageWidth - 20, pageHeight - 30);

            pdf.setFont("helvetica", "normal");
            pdf.text("© Mahatma Gandhi University,Priyadarsini Hills, Kottayam, Kerala, India - 686560", pageWidth / 2, pageHeight - 20, { align: "center" });
            pdf.text(date, pageWidth / 2, pageHeight - 5, { align: "center" });
            pdf.text(`Page ${j} of ${totalPages} (Part ${index + 1} of ${studentChunks.length})`, pageWidth - 40, 30, { align: "right" });
          }

          return pdf;
        }).save();
      };

      // Process chunks sequentially with a small delay between each
      for (let i = 0; i < studentChunks.length; i++) {
        await generatePDFForChunk(studentChunks[i], i);
        if (i < studentChunks.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }

      setlodaing(false);
      toast.success(`Generated ${studentChunks.length} PDF${studentChunks.length > 1 ? 's' : ''}`);
    } catch (error) {
      setlodaing(false);
      toast.error("Error generating PDF");
      console.error("Error generating PDF:", error);
    }
  };



  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="my-page">

            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Course Registration Review</h5>
                          <div className="buttons-container">

                            <button
                              className="lbl2 btn btn-primary m-r-10"
                              onClick={handleGeneratePrintPDF}
                              title="Download"
                            >
                              <i class="bi bi-arrow-down-square"></i>
                            </button>


                          </div>
                        </div>

                      </div>
                      <div className="card-body">

                        <div className="card-body pdg">
                          <div className="table-responsive" style={{ overflowX: 'unset' }}>

                            <form className="form theme-form">
                              <div className="card-body custom-input">


                                <div className="row">
                                  <div className="col-md-3">
                                    <label>Admission Year <span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="admyear"
                                      name="admyear"
                                      className="form"
                                      styles={customStyles}
                                      options={admissionYears}
                                      onChange={handleAdmissionYearChange}
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>Semester <span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="semester_id"
                                      name="semester_id"
                                      className="form"
                                      styles={customStyles}
                                      options={[
                                        { value: 1, label: '1' },
                                        { value: 2, label: '2' }
                                      ]}
                                      onChange={(option) => setSemester(option.value)}
                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>Discipline <span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={disciplineStyles}
                                      onChange={handleDisciplineChange}
                                      options={flag
                                        ? [{ value: '0', label: 'No data found' }]
                                        : disciplinedata
                                          .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                          .map(disciplines => ({
                                            did: disciplines.discipline_id,
                                            value: disciplines.discipline_name,
                                            label: disciplines.discipline_name,
                                            type: disciplines.college_course_type,
                                          }))
                                      }


                                    />
                                  </div>

                                  <div className="col-md-3">
                                    <label>Candidates</label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="candidate"
                                      name="candidate"
                                      className="form"
                                      styles={customStyles}
                                      options={[
                                        { value: '', label: 'All' },
                                        { value: 1, label: 'Own college students' },
                                        { value: 2, label: 'Out-of-college students' }
                                      ]}
                                      onChange={(option) => setCandidateType(option.value)}
                                      defaultValue={{ value: 1, label: 'Own college students' }}
                                    />
                                  </div>
                                </div>

                                {/* <div className="txt-aln-jst m-10"><p>
                                  <span className="text-danger">Note: This page is intended to track the status of students, whether they have completed the course registration process or not. It is not meant for verifying the course registrations made by students. Verification should only be carried out after the student portal has closed. Please note that students can modify their course selections up until the portal's closing time.
                                  </span></p>
                                </div> */}
                                {/* <div class="floating-checkbox">
                                   <input id="select-all" type="checkbox" onClick="" /> 
                              <label for="select-all">Select All</label> 
                                </div> */}


                                <div class="table-container">
                                  <table className="display dataTable table-striped table-bordered" ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="bg-primary">
                                        {/* <th scope="col" style={{ width: 50 }}>
                                     <input id="select-all" type="checkbox" onClick="" /> 
                                  </th> */}
                                        <th scope="col" width="10%">Sl No</th>
                                        <th scope="col" width="15%">APAAR</th>
                                        <th scope="col" width="20%">Name</th>
                                        <th scope="col" width="60%">Courses</th>
                                        {/* <th scope="col" width="30%">Approve/ Reject</th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredStudents.length > 0 ? (
                                        filteredStudents.map(([apaarId, studentDetails], index) => (
                                          <tr key={apaarId}>
                                            {/* <td scope="row">
                                   <input type="checkbox" value={apaarId} /> 
                                  </td> */}
                                            <td data-label="Sl No">{index + 1}</td>
                                            <td data-label="APAAR Id">{apaarId}</td>
                                            <td data-label="Name">{studentDetails.studentname}</td>
                                            <td data-label="Courses"><div className="treeview">
                                              <ul>
                                                {studentDetails.courses.map((course, courseIndex) => (
                                                  <li key={courseIndex}>
                                                    {course.paper_identifier}: {course.course_name}


                                                  </li>
                                                ))}
                                              </ul>
                                            </div>

                                            </td>
                                            {/* <td data-label="Approve/ Reject"><textarea class="form-control" placeholder='Remarks'></textarea><br />
                                    <button class="btn btn-pill btn-outline-danger btn-sm" type="button">Reject</button>
                                    </td>  */}

                                          </tr>

                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="6" style={{ textAlign: 'center' }}>No data available</td>
                                        </tr>
                                      )}


                                    </tbody>
                                  </table>


                                </div>

                              </div>
                              <div className="col-md-12 txt-aln ">
                                {/* <textarea style={{ width: 400 }} placeholder='Remarks'></textarea><br />


                            <button className="btn btn-primary me-3" type="submit" onClick="">Approve All</button>  */}

                              </div>


                            </form>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
